import React, { useState, useEffect } from 'react'
import sendRegistraionRequest from './api/signup'
import validator from 'validator'
import { useAuth } from "./api/authStore"
import landingLogo from './img/landing-logo.png'

const SignUp = (props) => {

    const { user, getAccessTokenSilently, setToken, logout } = useAuth()

    const [showPassword, setShowPassword] = useState(false)
    const [showRePassword, setShowRePassword] = useState(false)
    const [isError, showError] = useState(false)
    const [errorText, setErrorText] = useState("")
    const [email, setEmail] = useState("")
    const [passwd, setPassword] = useState("")
    const [repasswd, setRePassword] = useState("")

    const [passwordHelperText, setPasswordHelperText] = useState("")
    const [rePasswordHelperText, setRePasswordHelperText] = useState("")
    const [emailHelperText, setEmailHelperText] = useState("")
    const [open, setOpen] = useState(false)
    const [openEmail, setOpenEmail] = useState(false)
    const [openRePassError, setRePassError] = useState(false)
    const [buttonStatus, setButtonStatus] = useState(true)

    
    const handleChangeLogin = (e) => {
        setEmail(e.target.value)
    }

    const handleEmailValidate = (e) => {
        const value = e.target.value
        if(emailValidate(value)){
            setEmail(value)
            if (!passwordValidate(passwd) || !handleReValidatePassword(repasswd)) {
                setButtonStatus(true)
            } else {
                setButtonStatus(false)
            }
            setOpenEmail(false)
        }else {
            setButtonStatus(true)
            setEmail(value)
            setOpenEmail(true)
        }
    }

    const handleChangePasswd = (e) => {
        setPassword(e.target.value)
    }

    const passwordValidate = (value) => {
  
        if (!validator.isStrongPassword(value, {
            minLength: 8, minLowercase: 1,
            minUppercase: 1, minNumbers: 1, minSymbols: 1
        })) {
            setPasswordHelperText("password should be at least 8 chars, 1 lower case, 1 upper case, 1 special chars, 1 number")
            return false
        } else {
            setPasswordHelperText("")
            return true
        }
    }

    const emailValidate = (email) => {
        const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,5}$/g
       
        if(email && email.match(isValidEmail)){
            setEmailHelperText("")
            return true
        } else {
            setEmailHelperText("incorrect email format")
            return false
        }
    }
 
    const handleValidatePassword = (value) => {
        if (!passwordValidate(value) ){
            setOpen(true)
            setButtonStatus(true)
            setPassword(value)
        }else {
            if(!emailValidate(email) || !handleReValidatePassword(repasswd)){
                setButtonStatus(true)
            } else {
                setButtonStatus(false)
            }
            setOpen(false)
            setPassword(value)
        }
    }

    const handleChangeRePasswd = (e) => {
        setRePassword(e.target.value)
    }

    const handleReValidatePassword = (repassword) => {
        setRePassword(repassword)

        if(passwd !== repassword) {
            setRePasswordHelperText("Password and Re-password are not equal")
            setRePassError(true)
            setButtonStatus(true)
            return false
        } else {
            setRePassError(false)
            setRePasswordHelperText("")
            // Проверяем все поля для активации кнопки
            if(emailValidate(email) && passwordValidate(passwd)) {
                setButtonStatus(false)
            }
            return true
        }
    }

    const handleClickShowPassword = () => setShowPassword((show) => !show)
    const handleClickShowRePassword = () => setShowRePassword((show) => !show)

    const handleSingUpButton = async() => {
        try {
            const result = await sendRegistraionRequest(email, passwd)
            setToken(result)
            window.location.href = '/proxies'
        } catch (e) {
            if (e === 'userExist') {
                setErrorText("User already exist.")
            } else {
                setErrorText("Error occurs, try again please.")
            }
            showError(true)
        }
    }


    return (
        <div style={{ 
            height: '100vh', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            background: 'var(--gradient-hero)',
            position: 'relative'
        }}>
            {/* Декоративный фон */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'radial-gradient(circle at 30% 20%, rgba(255, 107, 53, 0.1) 0%, transparent 50%)',
                pointerEvents: 'none'
            }} />
            
            <div className="form-card" style={{ width: '450px', minWidth: '450px' }}>
                {/* Логотип слева, заголовок по центру */}
                <div className="mobile-auth-header" style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    marginBottom: 'var(--spacing-xl)',
                    paddingBottom: 'var(--spacing-lg)',
                    borderBottom: '1px solid var(--light-gray)'
                }}>
                    <img 
                        src={landingLogo} 
                        alt="XSocks Logo" 
                        style={{
                            width: '60px',
                            height: '60px',
                            objectFit: 'contain',
                            filter: 'drop-shadow(0 4px 12px rgba(255, 107, 53, 0.3))',
                            position: 'absolute',
                            left: 'var(--spacing-md)'
                        }} 
                    />
                    <h2 style={{ margin: 0 }}>Sign Up</h2>
                </div>
                
                <div className="form-group">
                    <label className="form-label">Email</label>
                    <input
                        type="email"
                        className={`form-input ${openEmail ? 'error' : ''}`}
                        placeholder="yours@example.com"
                        value={email}
                        onChange={handleChangeLogin}
                        onBlur={handleEmailValidate}
                    />
                    <div className="form-error" style={{ minHeight: '20px' }}>
                        {emailHelperText && (
                            <span>⚠️ {emailHelperText}</span>
                        )}
                    </div>
                </div>
                
                <div className="form-group">
                    <label className="form-label">Password</label>
                    <div className="form-input-with-icon">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className={`form-input ${open ? 'error' : ''}`}
                            placeholder="your password"
                            value={passwd}
                            onChange={handleChangePasswd}
                            onBlur={(e) => handleValidatePassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="password-toggle"
                            onClick={handleClickShowPassword}
                        >
                            {showPassword ? '👁️' : '🙈'}
                        </button>
                    </div>
                    <div className="form-error" style={{ minHeight: '40px' }}>
                        {passwordHelperText && (
                            <span>⚠️ {passwordHelperText}</span>
                        )}
                    </div>
                </div>
                
                <div className="form-group">
                    <label className="form-label">Confirm Password</label>
                    <div className="form-input-with-icon">
                        <input
                            type={showRePassword ? 'text' : 'password'}
                            className={`form-input ${openRePassError ? 'error' : ''}`}
                            placeholder="re-enter password"
                            value={repasswd}
                            onChange={handleChangeRePasswd}
                            onBlur={(e) => handleReValidatePassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="password-toggle"
                            onClick={handleClickShowRePassword}
                        >
                            {showRePassword ? '👁️' : '🙈'}
                        </button>
                    </div>
                    <div className="form-error" style={{ minHeight: '20px' }}>
                        {rePasswordHelperText && (
                            <span>⚠️ {rePasswordHelperText}</span>
                        )}
                    </div>
                </div>
                
                {isError && (
                    <div className="form-error">
                        ⚠️ {errorText}
                    </div>
                )}
                
                <button 
                    className={`btn btn-primary btn-large ${buttonStatus ? 'disabled' : ''}`}
                    onClick={handleSingUpButton}
                    disabled={buttonStatus}
                    style={{ 
                        width: '100%', 
                        marginBottom: '24px',
                        opacity: buttonStatus ? 0.5 : 1,
                        cursor: buttonStatus ? 'not-allowed' : 'pointer'
                    }}
                >
                    Sign Up
                </button>
                
                <div className="form-link">
                    <p style={{ color: 'var(--text-muted)', margin: '0 0 8px 0' }}>
                        Already have an account?
                    </p>
                    <a href="/login">Sign In!</a>
                </div>
                
                <div className="support-info" style={{ 
                    marginTop: '32px', 
                    paddingTop: '24px', 
                    borderTop: '1px solid var(--light-gray)',
                    fontSize: 'var(--text-sm)',
                    color: 'var(--text-muted)'
                }}>
                    <p style={{ margin: '0 0 8px 0' }}>
                        Support email: <a href={`mailto:${process.env.REACT_APP_EMAIL}`}>{process.env.REACT_APP_EMAIL}</a>
                    </p>
                    <p style={{ margin: '0' }}>
                        Support telegram: <a href={`tg://resolve?domain=${process.env.REACT_APP_TG}`}>{process.env.REACT_APP_TG}</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SignUp